<template>
  <div id="app">
    <component :is="layout" :class="layout">
      <router-view/>
    </component>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  mounted() {
    setTimeout(() => { // 刷新页面记录访问量
      axios.get(`${window.commonApi.TASKCENTER_API_URL}/api/app/accessRecord?labelName=loginOnce`).then(res => {
      }).catch(error => {
        console.log(error);
      });
    }, 50)
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcUser"]),
    getMobile() {
      var flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null) {
        return false;
      } else {
        return true;
      }
    },
    layout() {
      let meta = this.getMobile;
      let layout = meta ? 'mobile' : 'pc';
      return layout;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue